import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { DataGrid, GridColDef, GridRowSelectionModel, GridToolbarContainer, GridToolbarFilterButton, GridValueGetterParams } from '@mui/x-data-grid';
import { debounce } from 'lodash';
import * as React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { triggerAppAlert } from '../../../../redux/actions/SelfServicePortal/ContactAid/ContactAid';
import { bulkUpdateNewTickets, getBulkNewTicket, storeAllCSVResponses } from '../../../../redux/actions/TicketsManagement/TicketsManagement';
import { IState } from '../../../../redux/reducers/rootReducers';
import CustomDialog from '../../../common/dialog/CustomDialog';
import Breadcrumbs from "../../../common2/Breadcrumbs";
import ConfirmationPopup from '../../../common2/ConfirmationPopup';
import TopFilterNew from '../../../common2/TopFilterNew';
import CSVLoader from '../../../ReportsTest/CSVLoader';
import AgentGroupOption from './AgentGroupOption';
import { TicketViewPopup } from '../../../TicketManagementSystem/Modules/TicketViewPopup';
import { useLocation } from 'react-router-dom';

function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton /> */}
        <GridToolbarFilterButton />
        {/* <GridToolbarDensitySelector />
        <GridToolbarExport /> */}
      </GridToolbarContainer>
    );
}
interface IAllNewTicketsProps{
    allTickets:any;
    allResponses:any;
    dispatch:any
}
const getGroupIdsFromUrl = () =>{
    try {
        // URL to extract the groupIds from
        const url = window.location.href;

        // Extract the query string from the hash
        const queryString = url.split('?')[1];

        // Use URLSearchParams to parse the query string
        const params = new URLSearchParams(queryString);

        // Get the groupIds parameter value
        const groupIds = params.get('groupIds'); // "2,3"

        // Convert it into an array, if needed
        const groupIdsArray = groupIds ? groupIds.split(',').map(Number) : [];

//         console.log(groupIds);       // Output: "2,3"
//         console.log(groupIdsArray);  // Output: [2, 3]
        return groupIdsArray;
    } catch (error) {
        return [];   
    }
}
export function AllNewTickets({allTickets=[],allResponses={},dispatch}:IAllNewTicketsProps) {
    const location = useLocation();
    const queryParamStatus = new URLSearchParams(location.search).get("status");
    // const chosenAgents = useSelector((state: IState) => state?.filtersTicketManagementReducer?.agents);
    const AllData = useSelector((state: IState) => state?.TicketsReducer?.allResponses);
    const FiltersVal: any = useSelector((state: IState) => state?.filtersTicketManagementReducer);
    const {agentsWithGroup,agents} = FiltersVal;
    const groupIdsForBulkupdate = (agentsWithGroup:any,AllData:any) => {
        const tempObj: any = {
        agentGroupObj: {
            agents: [],
            groups: [],
          },
          allGroupIds:[]
            };

         if (agentsWithGroup?.length > 0) {
            for (let i of agentsWithGroup) {
                if (i.agentId !== 0 && !tempObj.agentGroupObj.agents.includes(i.agentId))
                tempObj.agentGroupObj.agents.push(i.agentId);
                if (!tempObj.agentGroupObj.groups.includes(i.groupId))
                tempObj.agentGroupObj.groups.push(i.groupId);
            }
         }
            tempObj.allGroupIds = AllData?.groups?.map
            ? AllData?.groups.map((i: any) => i.id)
            : [];
       return tempObj
    }
   const {agentGroupObj,allGroupIds} = groupIdsForBulkupdate(agentsWithGroup,AllData)

    const getValue = (params:GridValueGetterParams|any) => {
        return new Date(params.row.openDateTime).getTime();
    }
    const columns: GridColDef[] = [
    {
        "field": "id",
        "headerName": "ID",
        "width": 100,
        renderCell: (params) => (
                <Typography className='cursor-pointer' onClick={
                    ()=>{
                        dispatch({
                        type: "TICKET_VIEW_INFO",
                        payload: {ticketId:params.row.id,type:"quick-update"},
                        });
                    }
                }>
                {params.row.id}</Typography>
        )
    },
    {
        "field": "sourceCode",
        "headerName": "Source",
        "width": 150
    },
    {
        "field": "title",
        "headerName": "Subject",
        "width": 250
    },
    {
        "field": "openDateTime",
        "headerName": "Open Date",
        "width": 150,
        valueGetter: getValue,
        renderCell: (params) => {
            return params.row.openDateFormatted;
        }
    },
    {
      "field": "ticketStatus",
      "headerName": "Status",
      "width": 150,
    },
    {
        "field": "group",
        "headerName": "Group",
        "width": 150
    },
    {
        "field": "agent",
        "headerName": "Owner",
        "width": 150
    },
    {
        "field": "contacts",
        "headerName": "Contact",
        "width": 150
    },
    {
        "field": "contactOrganisationName",
        "headerName": "Organisation",
        "width": 150
    }
];
    const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>([]);
    const loadTickets = debounce((search:string="",statusIds:number[]=[],groupIds:number[]=[],agentIds:number[] = []) =>{
        dispatch(getBulkNewTicket(search,statusIds,groupIds,1000,getBulkNewTicketCB,agentIds))
    },150);
    const getBulkNewTicketCB = () =>{
        setRowSelectionModel([])
    }


    const table = React.useMemo(()=>{
        return <DataGrid 
                    rows={allTickets} 
                    columns={columns} 
                    checkboxSelection
                    onRowSelectionModelChange={(newRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel);
                    }}
                    rowSelectionModel={rowSelectionModel}
                    disableRowSelectionOnClick
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                    className="small-header"
                />
    },[allTickets?.length,rowSelectionModel.length])
    const loader = React.useMemo(()=>{
        return <CSVLoader />
    },[])
    React.useEffect(()=>{
        getAllTicket()
        return()=>{
            dispatch(storeAllCSVResponses([]))
        }
    },[])

    const getAllTicket = (searchVal?: string) => {
        // console.log("AllNewTickets", allResponses?.ticketStatus, allResponses?.groups);

        const statusIds: number[] =
            allResponses?.ticketStatus
            ?.filter((i: any) => !queryParamStatus || i.name === queryParamStatus)
            .map((i: any) => i.id) ?? [];

        // const groupIdsFromURL = getGroupIdsFromUrl();
        // console.log("groupIdsFromURL_",groupIdsFromURL)
        // const groupIds: number[] =
        //     groupIdsFromURL.length > 0
        //     ? groupIdsFromURL
        //     : allResponses?.groups?.map((i: any) => i.id) ?? [];


      const groupIds = agentsWithGroup?.length > 0
              ? agentGroupObj.groups
              : [0, ...allGroupIds]

       const chosenAgents = agentsWithGroup?.length > 0 ? agentGroupObj.agents : agents;
        loadTickets(
            searchVal ?? "",
            statusIds,
            groupIds,
            queryParamStatus === "New" ? chosenAgents : chosenAgents
        );
    };


    
    return (
        <>
            <Breadcrumbs
                data={[
                {
                    title: "Ticket ManagementSys ",
                    path: "/TicketManagementSys",
                },
                {
                    title: `Bulk Update`,
                    path: ``,
                    active: true
                },
                ]}
            />
            <Box className="allNew-tickets" style={{marginTop:"10px", height: "80vh", width: '100%' }}>
                {loader}
                {/* {allTickets?.length} {rowSelectionModel?.length} */}
                <FilterTickets rowSelectionModel={rowSelectionModel} loadTickets={getAllTicket} />
                
                {table}
            </Box>
            <TicketViewPopup />
            
        </>
    );
}

const FilterTickets = ({loadTickets,rowSelectionModel}:any) =>{
    const dispatch = useDispatch();
    const allResponses = useSelector((state:IState)=>state?.TicketsReducer?.allResponses?.ticketStatus);
    const [showAssign,setShowAssign] = React.useState(false);
    const [showDelete,setShowDelete] = React.useState(false);
    const [filterValues, setFilterValues] = React.useState({
        search : "",
        isActive : true,
    })
    const filterCallback = React.useCallback((values:any) =>{
        setFilterValues(values)
    },[])
    React.useEffect(()=>{
        // LoadTickets
        loadTickets(filterValues.search)
    },[filterValues])



    const deleteTickets = () =>{
        setShowDelete(true)
    }
    const assignTickets = () =>{
        setShowAssign(true)
    }
    const proceedDeleteItems = () =>{
        const deleteId = allResponses.find((x:any)=>x.name === "Delete")?.id;
//         console.log("rowSelectionModel",rowSelectionModel,allResponses,deleteId);

        if(!deleteId) {
            dispatch(triggerAppAlert(`User doesn't have Role Permission to Delete! Please contact Admin.`, 'warning'))
            return;
        };
        // return;
        const payload = {
            "sourceCode": "System",
            "actionType": "BulkDelete",
            "ticketLogs": {
                "sourceCode": "System",
                "statusId": deleteId
            }
        }
        dispatch(bulkUpdateNewTickets(rowSelectionModel,payload,bulkUpdateNewTicketsCB))
    }
    const bulkUpdateNewTicketsCB = () =>{
        setShowDelete(false)
        loadTickets(filterValues.search)
    }
    return(
        <>
            <TopFilterNew 
                callback = {filterCallback}
                backNavigationPath = "/TicketManagementSys"
                hideAddBtn = {true}
                hideToggleBtns = {true}
                extraFeatures={<>
                    {rowSelectionModel.length > 0 &&<>
                        <Tooltip title={`Delete Selected Items`}>
                            <Button onClick={deleteTickets}><DeleteOutlineIcon /></Button>
                        </Tooltip>
                        <Tooltip title={`Assign Selected Items`}>
                            <Button onClick={assignTickets}><GroupAddIcon /> </Button>
                        </Tooltip>
                        <Typography component="span">{rowSelectionModel.length} Item{rowSelectionModel.length ===1 ? "" : "s"} selected.</Typography>
                    </>}
                </>}
            />



            {showDelete && 
                <ConfirmationPopup 
                    onClose = {()=>{setShowDelete(false)}}
                    onSubmit = {proceedDeleteItems}
                    title = "Warning" 
                    desc = "Are you sure you want to delete the selected tickets?"
                />
            }
            {showAssign && <>
                <CustomDialog
                    heading={`Update Selected Tickets`}
                    body={
                    <>
                       <AssignAgentForm
                        selectedTicketIds = {rowSelectionModel}
                        handleClose={() => {
                            setShowAssign(false);
                        }}
                       />
                    </>
                    }
                    open={true}
                    handleClose={() => {
                        setShowAssign(false);
                    }}
                />
            </>}
        </>
    )
}


const AssignAgentForm = ({selectedTicketIds,handleClose}:any) =>{
    return(<>
        <AgentGroupOption statusToUpdate="NewtoMe" selectedTicketIds={selectedTicketIds} handleClose={handleClose}/>
    </>)
}

const mapStateToProps = (state:IState) => {
    return ({
      allTickets: state?.AllTicketsReducer?.allTickets,
      allResponses : state?.TicketsReducer?.allResponses
    })
  };
  
export default connect(mapStateToProps)(AllNewTickets);